export default "__VITE_ASSET__D0FWjJrC__"